import React from 'react';
import StartupIncludes from '../../components/StartupIncludes';
import StartupCard from '../StartupCard';
import productImage from './assets/product.png';
import brandImage from './assets/brand.png';
import designImage from './assets/design.png';
import marketingImage from './assets/marketing.png';
import devImage from './assets/dev.png';
import styles from './styles.scss';

function StartupCards () {
  return (
    <div className={`${styles.containerFix} container-fluid main-container mt100`}>
      <div className="col-md-8 col-center col-sm-12">
        <div className={`${styles.row} row`}>
          <div className="col-xs-12">
            <h1 className="bold-italics blue text-center mb50">
              So... $15k, what comes with that?
            </h1>
            <div className={styles.cardContainer}>
              <StartupCard
                image={productImage}
                title="Product Strategy"
                subtitle="strategy, research, projections"
              >
                <p>
                  You'll work with a product manager to develop a plan for your
                  startup or app idea.
                </p>
                <p>
                  This plan will contain your product's core features, light
                  market research, and key metrics for success.
                </p>
              </StartupCard>
              <StartupCard
                image={brandImage}
                title="Branding"
                subtitle="logo, branding, colors, fonts"
              >
                <p>
                  You'll have a dedicated brand designer creating your visual
                  communication.
                </p>
                <p>
                  This will take the form of a symbol logo, word logo, brand
                  colors and brand fonts.
                </p>
              </StartupCard>
              <StartupCard
                image={designImage}
                title="App Designs"
                subtitle="UI kit, wireframes, prototypes"
              >
                <p>
                  You'll have a dedicated app designer designing your web or
                  mobile app.
                </p>
                <p>
                  This will take the form of wireframes, page flow, and working
                  prototypes.
                </p>
              </StartupCard>
              <StartupCard
                image={marketingImage}
                title="Marketing"
                subtitle="pitchdeck, newsletters, social"
              >
                <p>
                  Your branding designer will continue to develop graphics to
                  represent your brand.
                </p>
                <p>
                  This will take the form of social media graphics, a business
                  card design, and a custom pitch deck.
                </p>
              </StartupCard>
              <StartupCard
                image={devImage}
                title="Plan for Development"
                subtitle="product plan, key technologies"
              >
                <p>
                  Your product manager will work with you to create a plan for
                  getting your app developed
                </p>
                <p>
                  This will take the form of a written plan detailing core
                  technologies needed and a certified list of developers.
                </p>
              </StartupCard>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-10 col-center col-sm-12">
        <div className={`${styles.row} row`}>
          <div className="col-xs-12">
            <StartupIncludes />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StartupCards;



// WEBPACK FOOTER //
// ./src/components/StartupCards/index.js